import React, { useState, useEffect } from "react";
import { Card, Image, Modal } from "antd";
import moment from "moment";
import { googleLayerAnalytics } from "../../../../utils/googleDataLayer";
import mixpanel from "mixpanel-browser";
import { mixPanelToken, isStage } from "../../../../config";
import less from "./busTimeline.module.scss";
import { analytics } from "../../../../utils/analytics";
import { useHistory } from "react-router-dom";

const _gaq = window._gaq || [];
const dateFormat = "hh:mm A";

// The stations the timeline lists between the passenger's boarding and drop
// (both excluded). Shared with the trip card's Non Stop tag.
export const getTimelineStations = (booking, busRoute) => {
  const route = Array.isArray(busRoute) ? busRoute : [];
  const fromPointId = booking?.boardingPoint?._id;
  const toPointId = booking?.dropPoint?._id;

  const fromIdx = route.findIndex(obj => obj.station._id === fromPointId);
  const toIdx = route.findIndex(obj => obj.station._id === toPointId);

  if (fromIdx !== -1 && toIdx !== -1 && fromIdx < toIdx - 1) {
    return route.slice(fromIdx + 1, toIdx);
  }

  return [];
};

const BusTimeline = props => {
  const [showRoute, setRouteVisibility] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [latLng, setLtLng] = useState({ lat: null, lng: null });

  const {
    booking,
    connectingFlag,
    isConnectingBooking,
    customerLatLng,
    busRoute,
    showStationChangeScreen,
    inventory_type,
    isLoungePassAvailable
  } = props;

  let boardingShowStatic3DView = false,
    boardingShowStaticOnlyView = false,
    boardingShowOnly3dView = false,
    boardingShowNone = false,
    dropPointShowStatic3DView = false,
    dropPointShowStaticOnlyView = false,
    dropPointShowOnly3dView = false,
    dropPointShowNone = false;

  if (booking.boardingPoint) {
    if (
      booking.boardingPoint.stationImagemain &&
      booking.boardingPoint.useStreetView
    ) {
      boardingShowStatic3DView = true;
    } else if (booking.boardingPoint.stationImagemain) {
      boardingShowStaticOnlyView = true;
    } else if (booking.boardingPoint.useStreetView) {
      boardingShowOnly3dView = true;
    } else {
      boardingShowNone = true;
    }
  }
  if (booking.dropPoint) {
    if (booking.dropPoint.stationImagemain && booking.dropPoint.useStreetView) {
      dropPointShowStatic3DView = true;
    } else if (booking.dropPoint.stationImagemain) {
      dropPointShowStaticOnlyView = true;
    } else if (booking.dropPoint.useStreetView) {
      dropPointShowOnly3dView = true;
    } else {
      dropPointShowNone = true;
    }
  }

  const isAgentBooking =
    booking.demandSource == "AGENT" || booking.demandSource == "AGENTPORTAL"
      ? true
      : false;

  const isOnboarded = !!booking.isOnboarded;

  const canChangeBoardingPoint =
    !booking.cabPickDropPnr &&
    !booking.fromStationUpdatedOnce &&
    !isConnectingBooking &&
    !connectingFlag &&
    booking.boardingPoint.time > Date.now() &&
    !isAgentBooking &&
    !isOnboarded;

  const canChangeDropPoint =
    !booking.cabPickDropPnr &&
    !booking.toStationUpdatedOnce &&
    !isConnectingBooking &&
    booking.dropPoint.time > Date.now() &&
    !isAgentBooking;

  const slicedRoute = getTimelineStations(booking, busRoute);

  let lastMarkedStation = null;

  for (let i = slicedRoute.length - 1; i >= 0; i--) {
    if (slicedRoute[i].stationMarked) {
      lastMarkedStation = slicedRoute[i];
      break;
    }
  }

  const mapsSelector = () => {
    const { lat, lng } = booking.boardingPoint;
    _gaq.push([
      "_trackEvent",
      "Get Directions",
      "Button Clicked",
      "click to see",
      1,
      true
    ]);
    googleLayerAnalytics("navigate_pickup", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource
    });
    if (Array.isArray(customerLatLng) && customerLatLng.length > 0) {
      analytics("Navigate", {
        mobile: booking.mobileNo,
        latitude: customerLatLng[0],
        longitude: customerLatLng[1]
      });
    }
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Directions Clicked", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      inventory: "ZINGBUS",
      inventory_type
    });
    window.location.href = `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
  };

  const history = useHistory();

  const handleBoardingChangeClick = () => {
    showStationChangeScreen(true, "Boarding Point");
    history.push("boardingChange");
    googleLayerAnalytics("boardingChange", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      booking_source: booking.demandSource
    });
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Change Boading Point", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      inventory: "ZINGBUS",
      inventory_type
    });
  };

  const handleDropChangeClick = () => {
    showStationChangeScreen(true, "Drop Point");
    history.push("DropPointChange");
    googleLayerAnalytics("DropPointChange", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      booking_source: booking.demandSource
    });
    mixpanel.init(mixPanelToken, { debug: isStage });
    mixpanel.track("Change Drop Point", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      inventory: "ZINGBUS",
      inventory_type
    });
  };

  const dropStationView = () => {
    mixpanel.track("Drop Point Images Viewed", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      inventory: "ZINGBUS",
      inventory_type
    });
  };

  const boardingStationView = () => {
    mixpanel.track("Boarding Point Images Viewed", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      inventory: "ZINGBUS",
      inventory_type
    });
  };

  const showIntermediateStation = () => {
    mixpanel.track("Itinerary Details Clicked", {
      mobile_no: booking.mobileNo,
      pnr: booking.bookingCode,
      trip_date: moment(booking.boardingPoint.time).format("YYYY-MM-DD"),
      from_city: booking.boardingPoint.city,
      to_city: booking.dropPoint.city,
      from_station: booking.boardingPoint.address,
      to_station: booking.dropPoint.address,
      booking_source: booking.demandSource,
      inventory: "ZINGBUS",
      inventory_type
    });
    setRouteVisibility(!showRoute);
  };

  const showStreetView = type => {
    if (!type) {
      setOpenModal(false);
      setLtLng({ lat: null, lng: null });
      return;
    }
    if (type === "boarding") {
      setLtLng({
        lat: booking.boardingPoint.lat,
        lng: booking.boardingPoint.lng
      });
    } else if (type === "drop") {
      setLtLng({
        lat: booking.dropPoint.lat,
        lng: booking.dropPoint.lng
      });
    }
    setOpenModal(true);
  };

  useEffect(() => {
    if (openModal) {
      const lat = parseFloat(latLng.lat); // Make sure these exist
      const lng = parseFloat(latLng.lng);

      new window.google.maps.StreetViewPanorama(
        document.getElementById("street-view-modal"),
        {
          position: { lat, lng },
          pov: { heading: 165, pitch: 0 },
          fullscreenControl: false,
          zoom: 1
        }
      );
    }
  }, [openModal]);

  return (
    <div className={less.wrapper}>
      <p>Timeline</p>
      <Card loading={false}>
        <div className={less.stations}>
          {boardingShowStatic3DView ? (
            <div
              className={less.streetViewIcon}
              onClick={() => showStreetView("boarding")}
            >
              <div className={less.img_wrapper}>
                <img
                  src={`https://d3bjx0rj820nz0.cloudfront.net/${booking.boardingPoint.stationId}/${booking.boardingPoint.stationImagemain}`}
                  alt="stationImage"
                />
              </div>

              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/street.svg"
                alt="person"
              />
            </div>
          ) : boardingShowStaticOnlyView ? (
            <Image
              width={60}
              height={60}
              alt="stationImage"
              onClick={() => boardingStationView()}
              src={`https://d3bjx0rj820nz0.cloudfront.net/${booking.boardingPoint.stationId}/${booking.boardingPoint.stationImagemain}`}
            />
          ) : boardingShowOnly3dView ? (
            <img
              onClick={() => showStreetView("boarding")}
              src="https://d1flzashw70bti.cloudfront.net/next-gen/images/selfHelp/threeDView.webp"
              alt="street-view"
            />
          ) : boardingShowNone ? (
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/stationImage.svg"
              alt="stationImage"
            />
          ) : null}

          <div className={less.details}>
            <span>Boarding at</span>
            <span>{booking.boardingPoint.name}</span>
            <span>
              {" "}
              {moment(booking.boardingPoint.time).format(dateFormat)}
            </span>
          </div>
          <div className={less.actions}>
            {isLoungePassAvailable ? null : (
              <div
                style={{ display: canChangeBoardingPoint ? "" : "none" }}
                onClick={handleBoardingChangeClick}
              >
                <img
                  alt="edit"
                  src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/changeStation.svg"
                />
                <span> Change</span>
              </div>
            )}
            <div onClick={mapsSelector}>
              <img
                alt="directions"
                src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/direction.svg"
              />
              <span> Directions</span>
            </div>
          </div>
        </div>
      </Card>
      <div className={less.connectingStrip}>
        <div />
      </div>
      <Card loading={false}>
        <div className={less.timeline}>
          <div
            className={less.toggle}
            onClick={() => showIntermediateStation()}
          >
            <span>
              {showRoute ? "Hide" : "Show"} all {slicedRoute.length}{" "}
              intermediate stations
            </span>
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/dropDown.svg"
              alt="drop-down"
            />
          </div>
          <div style={{ display: showRoute ? "" : "none", width: "100% " }}>
            {slicedRoute.map((obj, index) => (
              <div key={index} className={less.info}>
                <span>{moment(obj.reachingTime).format(dateFormat)}</span>
                <div className={less.routeLine}>
                  <div
                    className={
                      obj.stationMarked ? less.markedStrip : less.unmarkedStrip
                    }
                    style={{ visibility: index == "0" ? "hidden" : "" }}
                  />
                  {lastMarkedStation && obj._id === lastMarkedStation._id ? (
                    <img
                      src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/bus.svg"
                      alt="bus"
                    />
                  ) : (
                    <div
                      className={
                        obj.stationMarked
                          ? less.markedEllipses
                          : less.unmarkedEllipses
                      }
                    />
                  )}

                  <div
                    style={{
                      visibility:
                        index == slicedRoute.length - 1 ? "hidden" : ""
                    }}
                    className={
                      obj.stationMarked ? less.markedStrip : less.unmarkedStrip
                    }
                  />
                </div>
                <div>
                  <span>{obj.station.name}</span>

                  {obj.station.type == "RESTSTOP" ? (
                    <div className={less.reststops}>
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/rest-area1.svg"
                        alt="food"
                      />
                      <img
                        src="https://d1flzashw70bti.cloudfront.net/original/images/selfhelp/rest-area2.svg"
                        alt="food"
                      />
                      <span>Rest Stop</span>
                    </div>
                  ) : null}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Card>
      <div className={less.connectingStrip}>
        <div />
      </div>
      <Card loading={false}>
        <div className={less.stations}>
          {dropPointShowStatic3DView ? (
            <div
              className={less.streetViewIcon}
              onClick={() => showStreetView("drop")}
            >
              <div className={less.img_wrapper}>
                <img
                  src={`https://d3bjx0rj820nz0.cloudfront.net/${booking.dropPoint.stationId}/${booking.dropPoint.stationImagemain}`}
                  alt="stationImage"
                />
              </div>
              <img
                src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/street.svg"
                alt="person"
              />
            </div>
          ) : dropPointShowStaticOnlyView ? (
            <Image
              width={60}
              height={60}
              onClick={() => dropStationView()}
              alt="stationImage"
              src={`https://d3bjx0rj820nz0.cloudfront.net/${booking.dropPoint.stationId}/${booking.dropPoint.stationImagemain}`}
            />
          ) : dropPointShowOnly3dView ? (
            <img
              onClick={() => showStreetView("drop")}
              src="https://d1flzashw70bti.cloudfront.net/next-gen/images/selfHelp/threeDView.webp"
              alt="street-view"
            />
          ) : dropPointShowNone ? (
            <img
              src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/stationImage.svg"
              alt="stationImage"
            />
          ) : null}

          <div className={less.details}>
            <span>Drop at</span>
            <span> {booking.dropPoint.name}</span>
            <span>{moment(booking.dropPoint.time).format(dateFormat)}</span>
          </div>
          <div className={less.actions}>
            <div
              style={{ display: canChangeDropPoint ? "" : "none" }}
              onClick={handleDropChangeClick}
            >
              <img
                alt="edit"
                src="https://d1flzashw70bti.cloudfront.net/original/images/selfHelp/changeStation.svg"
              />
              <span> Change</span>
            </div>
          </div>
        </div>
      </Card>

      <Modal
        centered
        visible={openModal}
        footer={null}
        onCancel={() => setOpenModal(false)}
        width="90vw"
        bodyStyle={{ padding: 0 }}
        style={{ top: 0 }}
        className={less.streetModal}
      >
        <div id="street-view-modal" className={less.streetViewContainer} />
      </Modal>
    </div>
  );
};

export default BusTimeline;
